import { configureStore, Middleware } from '@reduxjs/toolkit';

import { baseApi } from 'api/api-base';
import { apiNotificationsMiddleware } from 'store/middlewares/api-notification-middleware';

import reducer from './reducer';

export const setupStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer,
    preloadedState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(baseApi.middleware, apiNotificationsMiddleware as Middleware),
  });

const store = setupStore();
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof reducer>;
